import { Button } from 'components/admin/ui/Button';
import { ConfirmationModal } from 'components/admin/ui/ConfirmationModal';
import { FormV2 } from 'components/ui';
import { Link03 } from 'ethena-icons';
import { useEffect, useState } from 'react';

interface ILinkModalProps {
  isVisible: boolean;
  onClose: () => void;
  onConfirm: (link: string) => void;
  value: string;
}

export const LinkModal = ({
  isVisible,
  onClose,
  onConfirm,
  value,
}: ILinkModalProps) => {
  const [link, setLink] = useState<string>(value);

  useEffect(() => setLink(value), [value, isVisible]);

  return (
    <ConfirmationModal isVisible={isVisible} onClose={onClose}>
      <ConfirmationModal.Header>
        <ConfirmationModal.Icon color="gray" icon={Link03} />
      </ConfirmationModal.Header>
      <ConfirmationModal.Body>
        <FormV2.Group>
          <FormV2.Label>Link</FormV2.Label>
          <FormV2.Control
            onChange={({ target }) => setLink(target.value)}
            placeholder="Link"
            value={link ?? ''}
          />
        </FormV2.Group>
      </ConfirmationModal.Body>
      <ConfirmationModal.Footer>
        <Button onClick={onClose} variant="outline">
          Cancel
        </Button>
        <Button onClick={() => onConfirm(link)}>Set link</Button>
      </ConfirmationModal.Footer>
    </ConfirmationModal>
  );
};
